if ( typeof ComparisonTable !== 'function' ) {
  class ComparisonTable extends HTMLElement {
    constructor() {
      super()
  
      this.tableEl = this.querySelector('.js-comparison-table')
      this.scrollEl = this.querySelector('.js-comparison-scroll')
      this.contentEl = this.querySelector('.js-comparison-content')
      this.headerEl = this.querySelector('.js-comparison-header')
      this.centerClass = 'comparison-table__center'

      const cellTopEls = this.querySelectorAll('.js-pc-cell-top')
  
      if (cellTopEls && cellTopEls.length) {
        setTimeout(() => {
          this.setModuleCenter()
        }, 1000)
  
        window.addEventListener('resize', () => {
          setTimeout(() => {
            this.setModuleCenter()
          }, 500)
        })
      }
  
      let lastPos = 0
      this.scrollEl.addEventListener('scroll', () => {
        const scrollLeft = this.scrollEl.scrollLeft
        const scrollWidth = this.scrollEl.scrollWidth - this.scrollEl.clientWidth
        const progress = scrollLeft / scrollWidth * 100
  
        const fill = this.scrollEl.querySelector('.js-progress-fill')
        if (fill) fill.style.width = `${progress}%`
  
        // scroll direction detection
        if (lastPos < scrollLeft) this.scrollRight()
        if (lastPos > scrollLeft) this.scrollLeft()
        lastPos = scrollLeft
      })
    }
  
    setModuleCenter () {
      this.tableEl.classList.remove(this.centerClass)
      const scrollWidth = this.scrollEl.clientWidth
      const contentWidth = this.contentEl.scrollWidth
  
      if (contentWidth > scrollWidth) {
        this.tableEl.classList.remove(this.centerClass)
        this.tableEl.classList.add('scrolling')
        this.headerEl.classList.add('scrolling')
      } else {
        this.tableEl.classList.add(this.centerClass)
        this.tableEl.classList.remove('scrolling')
        this.headerEl.classList.remove('scrolling')
      }
    }
  
    scrollRight () {
      this.tableEl.classList.add('scrolling-right')
      this.tableEl.classList.remove('scrolling-left')
    }
  
    scrollLeft () {
      this.tableEl.classList.add('scrolling-left')
      this.tableEl.classList.remove('scrolling-right')
    }
  }
  
  if ( typeof customElements.get('comparison-table') == 'undefined' ) {
    customElements.define('comparison-table', ComparisonTable);
  }
}
